module.exports = __webpack_public_path__ + "img/196.problem_urinals.32a73353.svg";